module.exports = __webpack_public_path__ + "img/bv-exchange.09659f1a.png";